import { blue, red } from '@material-ui/core/colors';
import { fuseDark } from '@fuse/fuse-colors';

const themesConfig = {
	default: {
		palette: {
			type: 'light',
			primary: fuseDark,
			secondary: {
				light: blue[600],
				main: blue[700],
				dark: blue[800]
			},
			error: red
		},
		status: {
			danger: 'orange'
		},
		overrides: {
			// Subtle modern rounding on all dialogs (matches the rounded
			// modalHeader top corners so they line up cleanly).
			MuiDialog: {
				paper: {
					borderRadius: 8
				}
			}
		}
	},
	defaultDark: {
		palette: {
			type: 'dark',
			primary: fuseDark,
			secondary: {
				light: blue[600],
				main: blue[700],
				dark: blue[800]
			},
			error: red,
			background: {
				paper: '#1E1E1E',
				default: '#1D222F'
			}
		},
		status: {
			danger: 'orange'
		},
		overrides: {
			// Subtle modern rounding on all dialogs (matches the rounded
			// modalHeader top corners so they line up cleanly).
			MuiDialog: {
				paper: {
					borderRadius: 8
				}
			}
		}
	}
};

export default themesConfig;
